<template>
    <div class="clearfix detail-acticle">
        <template v-for="v in list">
            <BaseText v-if="v.type=='text'" :text="v" :key="v.id" />

            <BaseList v-else-if="v.type=='list'" :text="v" :key="v.id" />

            <div v-else-if="v.type=='image'" class="detail-acticle-image-box" :key="v.id">
                <img class="detail-acticle-image" v-for="image in v.images" :src="image.url" :key="image.id">
            </div>
        </template>
    </div>
</template>
<script>
import BaseText from '@/components/module/BaseText'
import BaseList from '@/components/module/BaseList'

// import jquery from 'jquery'

export default {
    name: 'BaseArcticle',
    props: {
        list: Array
    },
    data: function() {
        return {

        }
    },
    components: {
        BaseText,
        BaseList
    },
    updated: function() {

    },
    mounted() {}
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media screen and (min-width: 801px) {
    .detail-acticle {
        max-width: 1200px;
        margin: 0 auto;
    }

    .detail-acticle-image-box {
        margin: 20px auto;
    }

    .detail-acticle-image {
        margin-bottom: 30px;
    }

}
@media screen and (max-width: 800px) {
    .detail-acticle {
        width: 9.04rem;
        margin: 0 auto;
    }

    .detail-acticle-image-box {
        margin: .533rem auto;
    }

    .detail-acticle-image {
        margin-bottom: .533rem;
    }

}
</style>